import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  last_page: null,
  data: [],
  search_result: [],
};

export const transactionSlice = createSlice({
  name: "transaction",
  initialState,
  reducers: {
    setTransactions: (state, action) => {
      state.current_page = action.payload.current_page;
      state.last_page = action.payload.last_page;
      state.data = action.payload.data;
    },
    setSearchRes: (state, action) => {
      state.search_result = action.payload;
    },
  },
});

export const { setTransactions, setSearchRes } = transactionSlice.actions;

export default transactionSlice.reducer;
